module.exports = __webpack_public_path__ + "static/media/ad0.33bed299.png";